import { render, staticRenderFns } from "./CompanyOrders.vue?vue&type=template&id=78eff4ac&scoped=true&"
import script from "./CompanyOrders.vue?vue&type=script&lang=js&"
export * from "./CompanyOrders.vue?vue&type=script&lang=js&"
import style0 from "./CompanyOrders.vue?vue&type=style&index=0&id=78eff4ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78eff4ac",
  null
  
)

export default component.exports